module.exports = __webpack_public_path__ + "img/slide-1.5045c811.webp";